import { render, staticRenderFns } from "./view-historique.html?vue&type=template&id=23c27678&scoped=true&external"
import script from "./view-historique.js?vue&type=script&lang=js&external"
export * from "./view-historique.js?vue&type=script&lang=js&external"
import style0 from "./view-historique.scss?vue&type=style&index=0&id=23c27678&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c27678",
  null
  
)

export default component.exports